import { ApiKeysActions } from '@store/reducers/apiKeys'
import { useDispatch } from 'react-redux'

import type { ApiKey } from '@/services/apiKeys'
import { OpenConfirmation } from '@/store'

export const useRevokeApiKey = () => {
  const dispatch = useDispatch()

  const revoke = (key: ApiKey) =>
    dispatch(
      OpenConfirmation({
        title: 'Revoke API key',
        message: `Revoke "${key.name}"? Any integration using this key will stop working immediately. This action can't be undone.`,
        label: 'Revoke',
        then: [ApiKeysActions.revoke({ id: key.id })],
      })
    )

  return { revoke }
}
